import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Copy, Check } from "lucide-react";
import { toast } from "sonner";

export function LinkDialog({ open, onClose, title, link, note }) {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(link);
    } catch (e) {
      const el = document.createElement("textarea");
      el.value = link;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
    }
    setCopied(true);
    toast.success("Link copied");
    setTimeout(() => setCopied(false), 1500);
  };
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="w-[calc(100%-1.5rem)] rounded-lg" data-testid="link-dialog">
        <DialogHeader>
          <DialogTitle>{title || "Copy link"}</DialogTitle>
        </DialogHeader>
        {note && <p className="text-sm text-slate-500">{note}</p>}
        <div className="flex items-center gap-2">
          <Input readOnly value={link || ""} data-testid="link-dialog-value" className="font-mono text-xs" />
          <Button onClick={copy} data-testid="link-dialog-copy" className="shrink-0">
            {copied ? <Check className="h-4 w-4" /> : <Copy className="h-4 w-4" />}
          </Button>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} data-testid="link-dialog-close">Done</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
